import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { client } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await client.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch (error) { console.error("Logout request failed", error); }
    setUser(null);
    window.location.href = "/";
  };

  const setRole = async (role) => {
    const r = await client.post("/auth/role", { role });
    setUser(r.data);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, logout, setRole, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
